import { Tab, Tabs, Typography } from '@material-ui/core';
import React, { useMemo, useState } from 'react';
import { COLORS } from 'shared/constants/COLORS';
import { IAuditionSchedulesAttributes } from 'shared/interfaces/IAuditionSchedule';
import { useAppSelector } from 'shared/redux/store';
import { ls } from 'shared/utils/ls';
import AuditionItem from '../AuditionItem/AuditionItem';
import { AuditionItemsContainer, Heading, ScrollCont } from '../Audtion.styles';
import LoadingCont from '../LoadingCont';
import { Badge, MainCont, NoData, useStyles } from './AuditionHistory.styles';

interface Props {
  declined: IAuditionSchedulesAttributes[];
  confirmed: IAuditionSchedulesAttributes[];
  pastSelftapes: IAuditionSchedulesAttributes[];
  declinedST: IAuditionSchedulesAttributes[];
  isLoading: boolean;
}

type ITab = 'studio_audtiion' | 'self_tapes';

const AuditionHistory: React.FC<Props> = ({ isLoading, confirmed, declined, pastSelftapes, declinedST }) => {
  const classes = useStyles();
  const { getLS, setLS } = ls();
  const { user: userState } = useAppSelector((state: any) => state);
  const isAuditionSTTab = Boolean(getLS('isAuditionSTTab') === 'true');
  const [tab, settab] = useState<ITab>(isAuditionSTTab ? 'self_tapes' : 'studio_audtiion');
  const country = userState?.user?.attributes?.other_phone_numbers?.filter((num) => num.type === 'primary');
  const userCountry = country && country.length > 0 ? country[0].country_code.toLowerCase() : 'au';
  const tabs = useMemo(() => {
    return [
      {
        name: 'studio_audtiion',
        header: 'Studio Audition',
        disabled: false,
        badge: isLoading ? 0 : confirmed.length + declined.length,
      },
      {
        name: 'self_tapes',
        header: 'Self Tapes',
        disabled: false,
        badge: isLoading ? 0 : pastSelftapes.length + declinedST.length,
      },
    ];
  }, [isLoading, confirmed, declined, pastSelftapes, declinedST]);

  const handleTabChange = (_: React.ChangeEvent<{}>, newValue: ITab) => {
    settab(newValue);
    if (newValue === 'self_tapes') {
      setLS('isAuditionSTTab', 'true');
    } else {
      setLS('isAuditionSTTab', 'false');
    }
  };

  const isSelftapes = tab === 'self_tapes';

  return isLoading ? (
    <LoadingCont />
  ) : (
    <MainCont>
      <Tabs
        className={classes.tabHeader}
        value={tab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        {(tabs || []).map((tab, index) => (
          <Tab
            key={index}
            label={
              <div className={classes.tabHeaderLabel}>
                <Typography>{tab.header}</Typography>
                <Badge disabled={tab.badge === 0}>
                  <Typography>{tab.badge}</Typography>
                </Badge>
              </div>
            }
            disabled={tab.disabled}
            value={tab.name}
            style={{ textTransform: 'capitalize' }}
          ></Tab>
        ))}
      </Tabs>
      {isSelftapes ? (
        <ScrollCont>
          {!pastSelftapes.length && !declinedST.length ? (
            <NoData>No Data Available</NoData>
          ) : (
            <>
              {pastSelftapes.length ? (
                <>
                  <Heading style={{ color: COLORS.SUCCESS, fontWeight: 600 }}>CONFIRMED</Heading>
                  <AuditionItemsContainer>
                    {pastSelftapes.map((a) => (
                      <AuditionItem country={userCountry} isHistory data={a} pastST />
                    ))}
                  </AuditionItemsContainer>
                </>
              ) : (
                <React.Fragment />
              )}
              {declinedST.length ? (
                <>
                  <Heading style={{ color: COLORS.DANGER, fontWeight: 600 }}>DECLINED</Heading>
                  <AuditionItemsContainer>
                    {declinedST.map((a) => (
                      <AuditionItem country={userCountry} isHistory data={a} />
                    ))}
                  </AuditionItemsContainer>
                </>
              ) : (
                <React.Fragment />
              )}
            </>
          )}
        </ScrollCont>
      ) : (
        <ScrollCont>
          {!confirmed.length && !declined.length ? (
            <NoData>No Data Available</NoData>
          ) : (
            <>
              {confirmed.length ? (
                <>
                  <Heading style={{ color: COLORS.SUCCESS, fontWeight: 600 }}>CONFIRMED</Heading>
                  <AuditionItemsContainer>
                    {confirmed.map((a) => (
                      <AuditionItem country={userCountry} isHistory data={a} />
                    ))}
                  </AuditionItemsContainer>
                </>
              ) : (
                <React.Fragment />
              )}
              {declined.length ? (
                <>
                  <Heading style={{ color: COLORS.DANGER, fontWeight: 600 }}>DECLINED</Heading>
                  <AuditionItemsContainer>
                    {declined.map((a) => (
                      <AuditionItem country={userCountry} isHistory data={a} />
                    ))}
                  </AuditionItemsContainer>
                </>
              ) : (
                <React.Fragment />
              )}
            </>
          )}
        </ScrollCont>
      )}
    </MainCont>
  );
};

export default AuditionHistory;
